import {createWebHistory, createRouter} from "vue-router";
import Home from "@/views/homeview.vue";
import ProfessorDetail from "@/views/ProfessorDetail.vue";
import ProfessorSearchResults from '@/views/ProfessorSearchResults.vue'
import SchoolSearchResults from '@/views/SchoolSearchResults.vue'
import UserCenter from '@/views/UserCenter.vue';
import ProfessorCreate from '@/views/ProfessorCreate.vue';
import TermsOfService from "@/views/TermsOfService.vue";
import ContactUs from "@/views/ContactUs.vue";
import FAQ from "@/views/FAQ.vue";
import About from "@/views/About.vue";
import AdminDashboard from "@/views/AdminDashboard.vue";
import axios from "axios";
import {API_BASE_URL} from "@/config";
import ElementPlus, {ElMessage} from "element-plus";

const routes = [
    {
        path: "/",
        name: "Home",
        component: Home,
    },
    {
        // path: "/professor/:id",
        path: '/professor/:id',
        name: "ProfessorDetail",
        component: ProfessorDetail,
        props: true // 启用props接收参数
    },
    {
        path: '/professors/search',
        name: 'ProfessorSearchResults',
        component: ProfessorSearchResults
    },
    {
        path: '/schools/search',
        name: 'SchoolSearchResults',
        component: SchoolSearchResults
    },
    {
        path: '/user/:username',
        name: 'UserCenter',
        component: UserCenter
    },
    {
        path: '/professor/create',
        name: 'ProfessorCreate',
        component: ProfessorCreate
    },
    {
        path: '/terms',
        name: 'TermsOfService',
        component: TermsOfService
    },
    {
        path: '/contact',
        name: 'ContactUs',
        component: ContactUs
    },
    {
        path: '/faq',
        name: 'FAQ',
        component: FAQ
    },
    {
        path: '/about',
        name: 'About',
        component: About
    },
    {
        path: '/aadmin',
        name: 'admin',
        component: AdminDashboard,
        meta: { requiresAdmin: true },
    },

];

const router = createRouter({
    // https://next.router.vuejs.org/guide/essentials/history-mode.html
    history: createWebHistory(),
    routes,
});

// 全局前置守卫
router.beforeEach(async (to, from, next) => {
    const token = localStorage.getItem('access.halfpanda');
    if (to.meta.requiresAdmin) {
        if (!token) {
            // 未登录，重定向到登录页
            next('/');
            return;
        }
        try {
            // 向后端验证权限
            const response = await axios.get(`${API_BASE_URL}/user/user-info`, {
                headers: {
                    'Authorization': token
                }
            });
            if (response.data.data.is_admin === 1) {
                ElMessage.success('验证成功');
                next();
            } else {
                // 不是管理员，重定向到首页
                next('/');
            }
        } catch (error) {
            // 验证失败，重定向到登录页
            next('/');
        }
    } else {
        next();
    }
});


export default router;